import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-organization-error',
  imports: [
    ButtonModule,
    RouterModule,
    TranslatePipe
  ],
  templateUrl: './organization-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class OrganizationErrorComponent {

}
